export default {
  airports: [],
};
